import { Component } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { ListFields } from '../../listfields';
import { RolloutHistory } from './rollout-history';
import { ActivatedRoute, Router } from '@angular/router';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { HttpService } from 'src/app/services/http.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-monitor-software',
  standalone: false,
  templateUrl: './monitor-software.component.html',
  styleUrl: './monitor-software.component.scss'
})
export class MonitorSoftwareComponent {

  public loading: boolean = false;
  public componentClassOptionsList: { id: number, name: string }[] = [];
  public rolloutHistoryFields: ListFields[] = [
    { Id: 0, FieldName: "Id", Uppercase: false, DisplayName: this.languageService.languageJSON.ManageBikes_RolloutId, SearchBy: true, GroupBy: true },
    { Id: 1, FieldName: "DateRange", Uppercase: false, DisplayName: this.languageService.languageJSON.MonitorSoftwareComponent_DateRange, SearchBy: true, GroupBy: true },
    { Id: 2, FieldName: "Type", Uppercase: false, DisplayName: this.languageService.languageJSON.Global_Type, SearchBy: true, GroupBy: true },
    { Id: 3, FieldName: "ActivationTrigger", Uppercase: true, DisplayName: this.languageService.languageJSON.MonitorSoftwareComponent_ActivationTrigger, SearchBy: true, GroupBy: true },
    { Id: 4, FieldName: "DeactivationTrigger", Uppercase: false, DisplayName: this.languageService.languageJSON.MonitorSoftwareComponent_DeactivationTrigger, SearchBy: true, GroupBy: true },
    { Id: 5, FieldName: "Bikes", Uppercase: true, DisplayName: this.languageService.languageJSON.Global_Bikes, SearchBy: true, GroupBy: true },
    { Id: 6, FieldName: "Deliveries", Uppercase: false, DisplayName: this.languageService.languageJSON.MonitorSoftwareComponent_Deliveries, SearchBy: true, GroupBy: true },
    { Id: 7, FieldName: "Success", Uppercase: false, DisplayName: this.languageService.languageJSON.MonitorSoftwareComponent_Successes, SearchBy: true, GroupBy: true },
    { Id: 8, FieldName: "SuccessRate", Uppercase: false, DisplayName: this.languageService.languageJSON.MonitorSoftwareComponent_SuccessesRate, SearchBy: true, GroupBy: true },
    { Id: 9, FieldName: "Errors", Uppercase: false, DisplayName: this.languageService.languageJSON.MonitorSoftwareComponent_Errors, SearchBy: true, GroupBy: true },
    { Id: 10, FieldName: "ErrorRate", Uppercase: false, DisplayName: this.languageService.languageJSON.MonitorSoftwareComponent_ErrorRate, SearchBy: true, GroupBy: true }
  ];

  public approvalRolloutHistoryList: RolloutHistory[] = [];
  public rolloutHistoryList: RolloutHistory[] = [];
  public releaseId: number = -1;
  public releaseName: string = "";
  public releaseVersion: string = "";
  public componentName: string = "";
  public componentClassName: string = "";
  public configIds: number[] = [];
  public configNames: string[] = [];
  public noDataError: boolean = false;
  public noDataString: string = "";

  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true
      }
    },
    maintainAspectRatio: false
  };

  public barChartType: ChartConfiguration['type'] = 'bar';
  public approvalBarChartShow: boolean = false;
  public approvalBarChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: []
  };
  public rolloutBarChartShow: boolean = false;
  public rolloutBarChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: []
  }

  constructor(public languageService: LanguageService, private router: Router, private httpService: HttpService,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.loading = true;

    this.route.queryParams
      .subscribe(params => {
        this.releaseId = params['id'];

        if (params['id']==undefined){
          this.router.navigate(['/software-overview']);
          return;
        }

        forkJoin([this.httpService.getComponentClassOptionsList(), this.httpService.getSoftwareMonitorList(this.releaseId)])
          .subscribe((resp: any) => {
            this.componentClassOptionsList = resp[0];
            if (resp[1]?.success) {
              this.releaseName = resp[1].data.filename;
              this.releaseVersion = resp[1].data.release_version;
              this.componentName = resp[1].data.component_variant.component.component_name;
              this.componentClassName = this.getComponentClass(resp[1].data.component_variant.component.component_class);
              this.configIds = resp[1].data.component_variant.configurations.map((el: any)=>{ return el.id });
              this.configNames = resp[1].data.component_variant.configurations.map((el: any)=>{ return el.config_name });

              this.approvalRolloutHistoryList = this.mapHistoryElement(resp[1].data.approval_rollouts, true);
              this.rolloutHistoryList = this.mapHistoryElement(resp[1].data.rollouts, false);

              this.initCharts();
              this.loading = false;
            }
            else{
              this.loading = false;
              this.noDataError = true;
              this.noDataString = this.languageService.languageJSON[`ReleaseDetails_ErrorCode_${resp[1].failed.code}`];
              if (this.noDataString == undefined || this.noDataString == ""){
                this.noDataString = this.languageService.languageJSON.ReleaseDetails_ErrorCode_E029;
              }
            }
          });
      });
  }

  private mapHistoryElement(rollouts: any, approval: boolean): RolloutHistory[] {
    if (approval) {
      return rollouts.map((el: any) => {
        return {
          Id: el.approval_rollout_id, DateRange: this.getDateRange(el.start_date, el.stop_date), Type: el.type, ActivationTrigger: el.activation_trigger,
          DeactivationTrigger: el.deactivation_trigger, Bikes: el.bikes, Deliveries: el.deliveries, Success: el.success,
          SuccessRate: el.success_rate, Errors: el.errors, ErrorRate: el.error_rate
        }
      });
    }
    else {
      return rollouts.map((el: any) => {
        return {
          Id: el.rollout_id, DateRange: this.getDateRange(el.start_date, el.stop_date), Type: el.type, ActivationTrigger: el.activation_trigger,
          DeactivationTrigger: el.deactivation_trigger, Bikes: el.bikes, Deliveries: el.deliveries, Success: el.success,
          SuccessRate: el.success_rate, Errors: el.errors, ErrorRate: el.error_rate
        }
      });
    }
  }

  private getDateRange(startDate: string, stopDate: string): string {
    if (stopDate == "0000-00-00" || stopDate == "Now" || stopDate == null) {
      return `${this.formatDate(startDate)} - ${this.languageService.languageJSON.MonitorSoftwareComponent_Now}`;
    }
    else {
      return `${this.formatDate(startDate)} - ${this.formatDate(stopDate)}`;
    }
  }

  private formatDate(dateString: string): string {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  private initCharts(): void {
    this.approvalBarChartShow = this.approvalRolloutHistoryList.findIndex((el) => { return el.Bikes >= 1 }) != -1;

    if (this.approvalBarChartShow) {
      this.approvalBarChartData = {
        labels: this.approvalRolloutHistoryList.map((el) => { return "R" + el.Id }),
        datasets:
          [{
            data: this.approvalRolloutHistoryList.map((el) => { return el.Bikes }),
            label: this.languageService.languageJSON.Global_Bikes,
            backgroundColor: 'rgba(33,130,198,0.85)',
            stack: "allBikes"
          }, {
            data: this.approvalRolloutHistoryList.map((el) => { return el.Success }),
            label: this.languageService.languageJSON.MonitorSoftwareComponent_Successes,
            backgroundColor: 'rgba(53,168,59,0.85)',
            stack: "successRate"
          },
          {
            data: this.approvalRolloutHistoryList.map((el) => { return el.Errors }),
            label: this.languageService.languageJSON.MonitorSoftwareComponent_Errors,
            backgroundColor: 'rgba(239,31,46,0.85)',
            stack: "successRate"
          }]
      };
    }

    this.rolloutBarChartShow = this.rolloutHistoryList.findIndex((el) => { return el.Bikes >= 1 }) != -1;

    if (this.rolloutBarChartShow) {
      this.rolloutBarChartData = {
        labels: this.rolloutHistoryList.map((el) => { return "R" + el.Id }),
        datasets:
          [{
            data: this.rolloutHistoryList.map((el) => { return el.Bikes }),
            label: this.languageService.languageJSON.Global_Bikes,
            backgroundColor: 'rgba(33,130,198,0.85)',
            stack: "allBikes"
          }, {
            data: this.rolloutHistoryList.map((el) => { return el.Success }),
            label: this.languageService.languageJSON.MonitorSoftwareComponent_Successes,
            backgroundColor: 'rgba(53,168,59,0.85)',
            stack: "successRate"
          },
          {
            data: this.rolloutHistoryList.map((el) => { return el.Errors }),
            label: this.languageService.languageJSON.MonitorSoftwareComponent_Errors,
            backgroundColor: 'rgba(239,31,46,0.85)',
            stack: "successRate"
          }]
      };
    }
  }

  public getValue(historyElement: any, key: any): string {
    if (key == "Id") {
      return "R" + historyElement[key];
    }
    else {
      return historyElement[key];
    }
  }

  public isLinkValue(historyElement: any, key: any): boolean {
    return parseInt(historyElement[key]) > 0;
  }

  /** Returns component class name by id */
  public getComponentClass(id: number): string {
    return this.componentClassOptionsList.find((el) => { return el.id == id })?.name as string;
  }

  public openConfiguration(configId: number) {
    this.router.navigate(['/view-configuration'], { queryParams: { id: configId } });
  }

  public openSoftware() {
    this.router.navigate(['/view-software'], { queryParams: { id: this.releaseId } });
  }

  public openComponent(componentName: string) {
    this.router.navigate(['/components'], { queryParams: { name: componentName } });
  }

  public openBikesDetails(rollout: RolloutHistory, approval: number) {
    this.router.navigate(['/software-bikes-details'], { queryParams: { rolloutId: rollout.Id, approval: approval } });
  }

  public openDeliveriesDetails(rollout: RolloutHistory, approval: number) {
    this.router.navigate(['/software-deliveries-details'], { queryParams: { rolloutId: rollout.Id, approval: approval } });
  }

  public openSuccessDetails(rollout: RolloutHistory, approval: number) {
    this.router.navigate(['/software-success-details'], { queryParams: { rolloutId: rollout.Id, approval: approval } });
  }

  public openErrorsDetails(rollout: RolloutHistory, approval: number) {
    this.router.navigate(['/software-errors-details'], { queryParams: { rolloutId: rollout.Id, approval: approval } });
  }
}
